module.exports = __webpack_public_path__ + "images/ui-icons_ffd27a_256x240.png";